import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_2 = { class: "dropdown__item--icon" }
const _hoisted_3 = { class: "dropdown__item--icon" }
const _hoisted_4 = { class: "dropdown__item--icon" }

import {UserCircle, Users03, LogOut04} from "utruckin-icons";
import {onBeforeUnmount, onMounted, ref} from "vue";
import {removeToken} from "@/utils/token";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetProfile',
  setup(__props) {

const router = useRouter();

const isDropdownVisible = ref<boolean>(false);
const profileRef = ref<HTMLElement | null>(null)

const toggleDropdown = () => {
  isDropdownVisible.value = !isDropdownVisible.value;
}

const closeDropdown = () => {
  isDropdownVisible.value = false
}

const handleClickOutside = (event: MouseEvent) => {
  if (
      profileRef.value &&
      !profileRef.value.contains(event.target as Node)
  ) {
    closeDropdown()
  }
}

const handleEsc = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    closeDropdown()
  }
}

const signOut = () => {
  removeToken()
  router.push("/")
}

const goToSettings = (type: 'profile' | 'users') => {
  router.push({
    path: "/settings",
    query: {
      name: type
    }
  })

  closeDropdown()
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
  document.addEventListener('keydown', handleEsc)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
  document.removeEventListener('keydown', handleEsc)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-profile",
    ref_key: "profileRef",
    ref: profileRef
  }, [
    _createElementVNode("div", {
      class: "body",
      onClick: toggleDropdown
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "body__icon" }, " SA ", -1),
      _createElementVNode("div", { class: "body__title" }, " Super admin ", -1)
    ]))]),
    (isDropdownVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "dropdown__item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToSettings('profile')))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(UserCircle), { size: 16 })
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dropdown__item--title" }, " Profile ", -1))
          ]),
          _createElementVNode("div", {
            class: "dropdown__item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToSettings('users')))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Users03), { size: 16 })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dropdown__item--title" }, " Users ", -1))
          ]),
          _createElementVNode("div", {
            class: "dropdown__item",
            onClick: signOut
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(LogOut04), { size: 16 })
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dropdown__item--title" }, " Sign out ", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})